import React from 'react';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_EXPIRING_REWARDS} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {ClientsExpiringRewardsContent} from './ClientsExpiringRewardsContent';
import reportPayload from './reportPayload';

export const ClientsExpiringRewardsReport = ({
  loadingData = {total: 0}, // Default value for loadingData
  tt = (key: string, defaultValue?: string) => defaultValue || '', // Default translation function
  showRecordPopover = () => {}, // No-op function
}: ReportProps) => {
  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );
  const premierValue = updatePremierPlus ? 'Premier+' : 'Premier';

  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Organization Clients with Expiring Rewards')}
      description={tt(
        'description',
        `These Clients have Rewards to be used on their next ${premierValue} order - reach out to them today so that they have a chance to use them!`,
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={ClientsExpiringRewardsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.expiringRewardsClients'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_EXPIRING_REWARDS,
    popoverContentProps: {},
  }),
)(ClientsExpiringRewardsReport);
